import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";

export const documentaryResourceArchive = createAsyncThunk<void, string, { extra: Partial<Dependencies> }>(
  "documentaryResource/archive",
  async (resourceId: string, { extra: { adminRepository } }) => {
    return adminRepository!.archiveDocumentaryResource(resourceId);
  },
);

export const documentaryResourceArchiveReset = createAction("documentaryResource/archiveReset");
